import apiClient from '@shared/api'
import type { UnreadMessagesByGroupMap } from '@shared/types/messaging'
import { useUnreadMessagesStore } from '@/shared/store/unreadMessages'

export const getMessagingAuthToken = (userId: string): Promise<{ authToken: string }> => {
  return apiClient.get(`/messaging/users/${userId}`)
}

export const getUnreadMessagesByGroup = (userId: string): Promise<UnreadMessagesByGroupMap> => {
  return apiClient.get(`/messaging/users/${userId}/unread`)
}

export const checkForUnreadMessages = async (userId: string) => {
  const unreadMessagesStore = useUnreadMessagesStore()
  const unreadMessagesByGroup = await getUnreadMessagesByGroup(userId)
  unreadMessagesStore.setUnreadMessagesByGroup(unreadMessagesByGroup)
}
